window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.customMedia = {
  '--xs': '(min-width: 540px)',
  '--sm': '(min-width: 720px)',
  '--md': '(min-width: 960px)',
  '--lg': '(min-width: 1240px)',
  '--xl': '(min-width: 1600px)',
  '--xxs-max': '(max-width: 539px)',
  '--xs-max': '(max-width: 719px)',
  '--sm-max': '(max-width: 959px)',
  '--md-max': '(max-width: 1239px)',
  '--lg-max': '(max-width: 1599px)',
};
